import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api from "@/lib/api";
import { AccountsPack } from "@/pages/AccountsPrint";

export default function PublicAccounts() {
    const { token } = useParams();
    const [payload, setPayload] = useState(null);
    const [err, setErr] = useState(null);

    useEffect(() => {
        api.get(`/public/accounts/${token}`)
            .then((r) => setPayload(r.data))
            .catch((e) => setErr(e.response?.status === 404 ? "This accounts link is not valid or has been withdrawn." : "Unable to load these accounts right now."));
    }, [token]);

    if (err) return (
        <div style={{ minHeight: "100vh", display: "flex", alignItems: "center", justifyContent: "center", fontFamily: "'IBM Plex Sans',sans-serif", background: "#f5f7f9" }}>
            <div style={{ textAlign: "center", color: "#556" }} data-testid="share-error">
                <div style={{ fontFamily: "'Chivo',sans-serif", letterSpacing: 4, color: "#1e5a85", fontWeight: 700, fontSize: 13, marginBottom: 12 }}>QUBE ACCOUNTANTS</div>
                <p style={{ fontSize: 15 }}>{err}</p>
            </div>
        </div>
    );
    if (!payload) return <div style={{ padding: 40, fontFamily: "'IBM Plex Sans',sans-serif" }} data-testid="share-loading">Loading accounts…</div>;

    return (
        <div data-testid="public-accounts-page">
            <div style={{ background: "#1e5a85", color: "#fff", padding: "10px 20px", fontFamily: "'IBM Plex Sans',sans-serif", fontSize: 13, display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ fontFamily: "'Chivo',sans-serif", letterSpacing: 3, fontWeight: 700 }}>QUBE ACCOUNTANTS</span>
                <span style={{ opacity: 0.85 }}>Interactive service charge accounts — hover a note number to preview it</span>
            </div>
            <AccountsPack e={payload.engagement} acc={payload.accounts} reports={payload.reports} watermark={!(payload.accounts.is_approved && payload.accounts.watermark_removed)} interactive={true} />
        </div>
    );
}
